var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24ActionsInfoOutined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-actions-info_outined",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm.5,12h-1a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,10.5,14Zm0-6h-1A.5.5,0,0,1,9,7.5v-1A.5.5,0,0,1,9.5,6h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,10.5,8Z",
    transform: "translate(2 2)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24ActionsInfoOutined);
export default __webpack_public_path__ + "static/media/icon-24-actions-info_outined.eea962d50a2ca5dbf38a6c6629957382.svg";
export { ForwardRef as ReactComponent };